import { registerFormInputComponent } from '@vendure/admin-ui/core';
import { DateOnlyFormComponent } from './components/date-only-form/date-only-form.component';
import { TimeOnlyFormComponent } from './components/time-only-form/time-only-form.component';
import { StoreOperationFormComponent } from './components/store-operation-form/store-operation-form.component';
import { DisabledFormComponent } from './components/disabled-form/disabled-form.component';
import { DisabledBooleanFormComponent } from './components/disabled-boolean-form/disabled-boolean-form.component';
import { AvailableDaysFormComponent } from './components/available-days-form/available-days-form.component';
import { AvailableDatesFormComponent } from './components/available-dates-form/available-dates-form.component';
import { DisabledTextFormComponent } from './components/disabled-text-form/disabled-text-form.component';
import { DisabledDateTimeFormComponent } from './components/disabled-date-time-form/disabled-date-time-form.component';
import { AvailableMonthsFormComponent } from './components/available-months-form/available-months-form.component';
import { AvailableMonthDatesFormComponent } from './components/available-month-dates-form/available-month-dates-form.component';
import { AvailableDaysFormConditionalComponent } from './components/available-days-form-conditional/available-days-form-conditional.component';
import { AvailableMonthDatesFormConditionalComponent } from './components/available-month-dates-form-conditional/available-month-dates-form-conditional.component';
import { AvailableMonthsFormConditionalComponent } from './components/available-months-form-conditional/available-months-form-conditional.component';

export default [
    registerFormInputComponent('date-only-form-input', DateOnlyFormComponent),
    registerFormInputComponent('time-only-form-input', TimeOnlyFormComponent),
    registerFormInputComponent('store-operation-form-input', StoreOperationFormComponent),
    registerFormInputComponent('disabled-form-input', DisabledFormComponent),
    registerFormInputComponent('disabled-text-form-input', DisabledTextFormComponent),
    registerFormInputComponent('disabled-boolean-form-input', DisabledBooleanFormComponent),
    
    registerFormInputComponent('available-days-form-input', AvailableDaysFormComponent),
    registerFormInputComponent('available-days-form-conditional-input', AvailableDaysFormConditionalComponent),

    registerFormInputComponent('available-dates-form-input', AvailableDatesFormComponent),

    registerFormInputComponent('available-months-form-input', AvailableMonthsFormComponent),
    registerFormInputComponent('available-months-form-conditional-input', AvailableMonthsFormConditionalComponent),

    registerFormInputComponent('available-month-dates-form-input', AvailableMonthDatesFormComponent),
    registerFormInputComponent('available-months-dates-form-conditional-input', AvailableMonthDatesFormConditionalComponent),

    registerFormInputComponent('disabled-date-time-form-input', DisabledDateTimeFormComponent),
];
